// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__36D02","label":"Section_label__1Y35U","contentWrap":"Section_contentWrap__3UnoN","footer":"Section_footer__1xxjU","footerInner":"Section_footerInner__314ni"};